export const DROP_ZONE_BASE_ATTRIBUTES = {
    'aria-dropeffect': 'copy' as DataTransfer['dropEffect'],
    tabIndex: 0,
    role: 'button',
};
